import gsap, { Power2 as Ease } from 'gsap'

export class EntryForm {
  constructor() {
    this.el = document.getElementById('js-entry-form')
    if (this.el === null) return
    this.accordionInit([...this.el.querySelectorAll('.js-entry-accordion')])
    this.tabInit([...this.el.querySelectorAll('.wpcf7')], [...this.el.querySelectorAll('.js-entry-tab-button')])
  }

  tabInit(tabsEl, buttonsEl) {
    if (tabsEl.length <= 1 || tabsEl.length !== buttonsEl.length) return
    let current = 0

    tabsEl.forEach((tabEl, i) => {
      tabEl.style.top = 0
      tabEl.style.left = 0
      tabEl.style.width = '100%'
      if (i !== current) {
        tabEl.style.position = 'absolute'
        tabEl.style.visibility = 'hidden'
        tabEl.style.opacity = '0'
      }
    })

    buttonsEl.forEach((buttonEl, i) => {
      buttonEl.addEventListener('click', () => {
        console.log(current)
        current = i
        tabsEl.forEach((tabEl, i) => {
          if (i === current) {
            tabEl.style.position = 'absolute'
            tabEl.style.visibility = 'hidden'
            tabEl.style.opacity = '0'
          } else {
            tabEl.style.position = 'relative'
            tabEl.style.visibility = 'visible'
            tabEl.style.opacity = '1'
          }
        })
      })
    })
  }
  accordionInit(accordionsEl) {
    if (accordionsEl.length === 0) return
    accordionsEl.forEach((el) => {
      const radioWrapper = el.querySelector('.js-entry-accordion-radio')
      const container = el.querySelector('.js-entry-accordion-container')
      const inner = el.querySelector('.js-entry-accordion-inner')
      if (radioWrapper === null || container === null || inner === null) return
      const { value } = radioWrapper.dataset
      const radios = [...radioWrapper.querySelectorAll('input[type="radio"]')]
      if (!value || radios.length === 0) return

      let isOpen = false

      container.style.cssText = `
      position: relative;
      overflow: hidden;
      height: 0;
      `
      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (radio.value === value && !isOpen) {
            isOpen = true
            gsap.to(container, 0.5, {
              ease: Ease.easeOut,
              height: inner.clientHeight,
              onComplete: () => {
                container.style.height = 'auto'
              },
            })
          } else if (radio.value !== value && isOpen) {
            isOpen = false
            gsap.fromTo(
              container,
              0.5,
              {
                height: inner.clientHeight,
              },
              {
                ease: Ease.easeOut,
                height: 0,
              }
            )
          }
        })
      })
    })
  }
}
